<template>
  <label class="bear-checked-item">
    <img :src="icon" alt="Checkbox"><slot />
  </label>
</template>
<script>
import IconCheckedPrimary from '~@/tender-viewer/src/img/icon-checked-primary.png'
import IconUnChecked from '~@/tender-viewer/src/img/icon-unchecked.png'
export default {
  name: 'BearCheckedItem',
  props: {
    checked: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    icon () {
      return this.checked ? IconCheckedPrimary : IconUnChecked
    }
  }
}
</script>
<style lang="scss" scoped>
.bear-checked-item {
  padding: 0 0 0 10px;
  cursor: pointer;
  img {
    vertical-align: text-bottom;
    margin-right: 5px;
  }
}  
</style>